// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-Et7_I","loading":"loading-XgLFc"};